import React from "react";
import { MARQUEE_ITEMS } from "../mock";
import { Star } from "lucide-react";

const Marquee = () => {
  const loop = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="bg-[#DD4D2A] text-[#FFF2EC] overflow-hidden border-y border-[#1A1410]/10">
      <div className="marquee-track flex whitespace-nowrap py-5">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-serif-display text-2xl md:text-3xl font-medium italic">
              {t}
            </span>
            <Star className="w-4 h-4 fill-[#FFF2EC] text-[#FFF2EC]" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
